import React from 'react';
import './MapSelectMarker.scss';

export interface Props {
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

const MapSelectMarker: React.FC<Props> = ({ onClick }: Props) => {
  return (
    <div className="map-select-marker-component" onClick={onClick}>
      <div className="marker-pin"></div>
      <div className="marker-pulse"></div>
    </div>
  );
}

export default MapSelectMarker;
